var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$parent.$parent.rerender)?_c('div',{staticClass:"row myrow content-mb-42"},[_c('div',{staticClass:"col-xs-12 mycol",class:{
      'has-error': _vm.$parent.$parent.checkErrorField(
        'PROJECTS',
        'LOGIC',
        'UF_AVAILABLE_RESULTS'
      )
    }},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.$parent.project.UF_AVAILABLE_RESULTS),expression:"$parent.project.UF_AVAILABLE_RESULTS"}],staticClass:"i-main-style t-dop-style i-wid-50",staticStyle:{"height":"70px"},attrs:{"disabled":_vm.$parent.$parent.projectDisabled,"placeholder":_vm.getPlacholder()},domProps:{"value":(_vm.$parent.project.UF_AVAILABLE_RESULTS)},on:{"keyup":function($event){return _vm.$parent.$parent.removeError(
          'PROJECTS',
          'LOGIC',
          'UF_AVAILABLE_RESULTS'
        )},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.$parent.project, "UF_AVAILABLE_RESULTS", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"error-text"},[_vm._v("\n      "+_vm._s(_vm.$parent.$parent.checkErrorText(
          "PROJECTS",
          "LOGIC",
          "UF_AVAILABLE_RESULTS"
        ))+"\n    ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }